"use client";
import { ProcessedCourse } from "@/common/course/types";
import getSmarterLogo from "@/public/images/getsmarter-logo.svg";
import Image from "next/image";
import useTranslations from "@/i18n/useTranslations";
interface CollaborationProps {
  course: ProcessedCourse;
  title?: string;
  description?: string;
  items?: {
    title?: string;
    text?: string;
  }[];
}

export default function Collaboration({
  course,
  title,
  description,
  items,
}: CollaborationProps) {
  const t = useTranslations("Common");
  return (
    <section id="collaboration">
      <h2 className="text-3xl font-bold text-gray-800 mb-4">{title}</h2>
      <p className="text-gray-600 italic mb-4">{description}</p>

      {items?.map((item) => (
        <div key={item.title}>
          <h3 className="text-xl font-bold text-gray-800 mb-4">{item.title}</h3>
          <p className="text-gray-600 italic mb-4">{item.text}</p>
        </div>
      ))}

      <div className="pt-8">
        <div className="flex flex-col md:flex-row gap-8">
          <div className="flex justify-center md:justify-start">
            <div className="w-[250px] bg-white rounded-[10px] py-20 px-10">
              <Image
                src={getSmarterLogo}
                alt={t("getSmarterAlt")}
                width={250}
                height={150}
                className="object-contain"
              />
            </div>
          </div>

          <div className="space-y-1">
            <h2 className="text-xl font-semibold text-foreground">
              About GetSmarter
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              GetSmarter, a 2U, LLC brand, collaborates with the world&apos;s
              leading universities and institutions to select, design, and
              deliver premium online short courses with a data-driven focus on
              learning gain.
            </p>
            <p className="text-muted-foreground leading-relaxed">
              Technology meets academic rigor in GetSmarter&apos;s
              people-mediated model, which enables lifelong learners across the
              globe to obtain industry-relevant skills that are recognized by
              the world&apos;s most reputable academic institutions.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
